import { PrinterIcon, XMarkIcon } from '@heroicons/react/24/solid';
import React, { useRef } from 'react';
import TranscriptToPrint from './TranscriptToPrint';
import { useReactToPrint } from 'react-to-print';

function PrintTranscript({ handleShowTranscript, lang, stringTranslations, transcript, transcriptTitle, }:any) {
  const contentRef = useRef(null);
  const handlePrint = useReactToPrint({
    documentTitle: transcriptTitle,
    content: () => contentRef.current,
  });
  return (
    <div className="bg-white text-black max-w-[710px] my-[21px]">
      <div className="bg-lightGrey flex items-center justify-between px-3 sm:px-6 md:px-3 lg:px-6 h-[57px]">
        <div className="flex items-center group">
          <button aria-label="print transcript" type="button" className="flex items-center" onClick={handlePrint}>
            <PrinterIcon className="mr-2 w-[1rem]" />
            <p className="inline-block uppercase text-chdBlue font-semibold text-[14px] tracking-wider leading-[42.5px] group-hover:text-chdBlue-dark">{stringTranslations['print-transcript'][lang]}</p>
          </button>
        </div>
        <button aria-label="close transcript" type="button" onClick={() => handleShowTranscript()}>
          <XMarkIcon strokeWidth={1} stroke="currentColor" className="size-8 hover:text-chdBlue-dark" />
        </button>
      </div>
      <TranscriptToPrint
        transcript={transcript}
        transcriptTitle={transcriptTitle}
        innerRef={contentRef}
      />
    </div>
  );
}

export default PrintTranscript;
